import type { PillVariant } from '@/components/common/Pill';
import type { MiniTortStage, PrerequisiteStatus } from '@/services/api/generated/miniTortService';

export const PREREQUISITE_READY: Set<PrerequisiteStatus> = new Set([
  'extracted', 'processed', 'complete', 'approved', 'manual', 'waived',
]);

export const MINI_TORT_STAGE_ORDER: MiniTortStage[] = [
  'processing_submission',
  'reviewing_claim',
  'need_additional_materials',
  'retrieving_police_report',
  'generating_demand',
  'demand_submitted',
  'insurer_acknowledged',
  'payment_issued',
  'payment_en_route',
  'closed',
];

export const MINI_TORT_STAGE_LABELS: Record<MiniTortStage, string> = {
  processing_submission: 'Processing',
  reviewing_claim: 'Reviewing Claim',
  need_additional_materials: 'Need Materials',
  retrieving_police_report: 'Police Report',
  generating_demand: 'Generating Demand',
  demand_submitted: 'Demand Submitted',
  insurer_acknowledged: 'Acknowledged',
  payment_issued: 'Payment Issued',
  payment_en_route: 'Payment En Route',
  closed: 'Closed',
  rejected: 'Rejected',
};

export const MINI_TORT_STAGE_COLORS: Record<MiniTortStage, PillVariant> = {
  processing_submission: 'yellow',
  reviewing_claim: 'purple',
  need_additional_materials: 'orange',
  retrieving_police_report: 'purple',
  generating_demand: 'purple',
  demand_submitted: 'purple',
  insurer_acknowledged: 'purple',
  payment_issued: 'green',
  payment_en_route: 'green',
  closed: 'gray',
  rejected: 'red',
};

export const VALID_TRANSITIONS: Record<MiniTortStage, MiniTortStage[]> = {
  processing_submission: ['reviewing_claim', 'rejected'],
  reviewing_claim: [
    'need_additional_materials',
    'retrieving_police_report',
    'generating_demand',
    'rejected',
  ],
  need_additional_materials: [
    'reviewing_claim',
    'retrieving_police_report',
    'generating_demand',
    'rejected',
  ],
  retrieving_police_report: [
    'generating_demand',
    'need_additional_materials',
    'rejected',
  ],
  generating_demand: ['demand_submitted'],
  demand_submitted: ['insurer_acknowledged', 'payment_issued'],
  insurer_acknowledged: ['payment_issued'],
  payment_issued: ['payment_en_route'],
  payment_en_route: ['closed'],
  closed: [],
  rejected: [],
};
